import { render, staticRenderFns } from "./StatsSite_html.vue?vue&type=template&id=5064d0f2&scoped=true"
import script from "./StatsSite_html.vue?vue&type=script&lang=js"
export * from "./StatsSite_html.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5064d0f2",
  null
  
)

export default component.exports